export var getPercent = function getPercent(prop) {
  if (typeof prop === 'string') {
    return prop;
  }

  if (typeof prop === 'number') {
    return prop + "%";
  }

  return 'auto';
};
export var getPx = function getPx(prop) {
  if (typeof prop === 'string') {
    return prop;
  }

  if (typeof prop === 'number') {
    return prop + "px";
  }

  return 'auto';
};
export var getMs = function getMs(duration) {
  if (typeof duration === 'number') {
    return duration + "ms";
  }

  return duration;
}; // Returns first defined argument, even if it's null or a falsy value

export var getDefined = function getDefined() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  for (var i = 0; i < args.length; i++) {
    if (args[i] !== undefined) {
      return args[i];
    }
  }
};